import { skipToken } from '@tanstack/react-query';
import { formatDatetime } from '../../utils/fieldFormats.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { CollectButton } from './collectButton.tsx';
import { EquipmentOption } from './types.ts';


interface Props {
    selectedEquipment: EquipmentOption | null;
}

// Shows collection controls and the part collected from the current batch.
export function CollectPanel({ selectedEquipment }: Props) {

    const { data: currentBatch } = trpc.batches.getCurrent.useQuery(
        selectedEquipment?.type === 'cnc' ? {
            equipment: selectedEquipment.id,
        } : skipToken,
        { refetchInterval: 10 * 60_000 },
    );
    const { data: partCollect } = trpc.partCollect.get.useQuery(
        selectedEquipment?.type === 'cnc' ? {
            equipment: selectedEquipment.id,
        } : skipToken,
        { refetchInterval: 60_000 },
    );

    const canCollect = selectedEquipment?.type === 'cnc' && currentBatch != null
        && currentBatch.equipment === selectedEquipment.id && currentBatch.end == null;
    const isCurrentBatch = canCollect && currentBatch != null && partCollect != null
        && partCollect.equipment === currentBatch.equipment
        && partCollect.product === currentBatch.product
        && partCollect.batchStart.getTime() === currentBatch.start.getTime();


    return (
        <div style={{
            marginLeft: '24px',
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
        }}>
            <CollectButton
                batch={currentBatch}
                canCollect={canCollect}
            />
            {(isCurrentBatch && partCollect) &&
                <small style={{ fontSize: '12px', textAlign: 'center' }}>
                    Collected at:<br />
                    {formatDatetime(partCollect.collectedAt)}
                </small>
            }
        </div>
    );
}
